module.exports = __webpack_public_path__ + "img/reminder.c81e39e5.svg";